import { FormSection } from "components/MainSectionTemplate/types";
import TwitterLink from "components/TwitterLink";
import WebsiteLink from "components/Website/WebsiteLink";
import React from "react";
import { ContactFormState } from "contact/models";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import { getInstruction } from "contact/utils";
import UrlInput from "components/urlinput";

export const socialsSection = (contact: server.dto.Contact, formState: ContactFormState): FormSection => {

  return {
    type: "collapsable",
    key: "socialsSection",
    title: "Socials",
    fields: [{
      key: "twitter",
      label: RESX.Contact.Twitter,
      render: () => <TwitterLink twitter={formState.twitter} />,
      isEmpty: !formState.twitter,
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxTwitterLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.twitter,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, { twitter: value });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "website",
      label: RESX.GeneralLabels.Website,
      render: () => <WebsiteLink website={formState.website} />,
      isEmpty: !formState.website,
      inPageEdit: {
        render: ({ value, onChange, cancel, submit }) => (
          <UrlInput
            focusOnMount
            value={value}
            onValueChange={onChange}
            validatorKey="contactWebsite"
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxNetworkPathLength}
          />
        ),
        type: "confirmOrCancelButton",
        fullWidth: true,
        initialValue: formState.website,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, { website: value });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "facebook",
      label: "Facebook",
      render: () => <WebsiteLink website={formState.facebook} />,
      isEmpty: !formState.facebook,
      inPageEdit: {
        render: ({ value, onChange, cancel, submit }) => (
          <UrlInput
            focusOnMount
            value={value}
            onValueChange={onChange}
            validatorKey="contactFacebook"
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.url.maxFacebookLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.facebook,
        fullWidth: true,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, { facebook: value });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "networkPath",
      label: RESX.Company.NetworkPath,
      render: () => <WebsiteLink website={formState.networkPath} />,
      isEmpty: !formState.networkPath,
      inPageEdit: {
        render: ({ value, onChange, cancel, submit }) => (
          <UrlInput
            focusOnMount
            value={value}
            onValueChange={onChange}
            validatorKey="contactNetworkPath"
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxNetworkPathLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.networkPath,
        fullWidth: true,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, { networkPath: value });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }]
  }
}